// @flow
import React from 'react';
import {FormattedMessage} from 'react-intl';

import Box from 'sail/Box';
import Group from 'sail/Group';
import {ButtonLink} from 'sail/Button';
import {BodyAlt, Heading} from 'sail/Text';
import Icon from 'sail/Icon';
import {UnstyledLink} from 'sail/UnstyledLink';
import {useAccount, useNavigation} from 'docs/data';
import {getLoginUrl} from 'docs/util';
import {DocsIcon} from 'docs/components';

import {headerMessages} from './Header.messages';

import './MobileNav.scss';

export const MobileNavRightLink = () => {
  const {account} = useAccount();

  return (
    <Box
      padding={{left: 32, right: 8}}
      flex={{alignItems: 'center'}}
      className="Header-buttons--small"
    >
      <Group direction="horizontal" spacing={8} alignItems="center">
        <BodyAlt>
          <ButtonLink
            color="gray700"
            label={
              account.user ? (
                <FormattedMessage {...headerMessages.dashboard} />
              ) : (
                <FormattedMessage {...headerMessages.signIn} />
              )
            }
            href={getLoginUrl({account})}
          />
        </BodyAlt>
        <Icon size={12} icon="arrowRight" />
      </Group>
    </Box>
  );
};

type MobileNavProps = {|
  +isMobileSearchOpen: boolean,
  +onToggleNavSearch: () => void,
|};

export const MobileNav = ({
  isMobileSearchOpen,
  onToggleNavSearch,
}: MobileNavProps) => {
  const {navigation} = useNavigation();
  const topics = navigation.topics;
  const activeTopic = topics.find((t) => t.active) || null;
  const activeProduct = navigation.products.find((p) => p.active);
  const activePage = (activeProduct?.children || []).find(
    (p) => p.active || false,
  );
  const labelText = activePage?.text ||
    activeProduct?.text ||
    activeTopic?.text || <FormattedMessage {...headerMessages.home} />;
  return (
    <Box className="MobileNav">
      <UnstyledLink className="MobileNav-button" onClick={onToggleNavSearch}>
        <Box flex={{alignItems: 'center'}}>
          <Box margin={{left: 8, right: 8}}>
            {isMobileSearchOpen ? (
              <Icon size={12} icon="cancel" />
            ) : (
              <DocsIcon size={12} category="nav" icon="mobilenav" />
            )}
          </Box>
          <Heading
            style={{
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
            }}
          >
            {labelText}
          </Heading>
        </Box>
      </UnstyledLink>
    </Box>
  );
};
